import React from 'react';

const AdvanceTrading = () => {
    // return (
    //     <div className="advance-trading py-5">
    //         <div className="container">
    //             <div className="row justify-content-center">
    //                 <div className="col-xl-6">
    //                     <div className="section-title text-center">
    //                         <h2>Advanced Trading</h2>
    //                         <p>Our platform offers cutting-edge features designed for both novice and experienced traders. Trade on advanced spot and margin markets with lightning-fast execution and deep liquidity, giving you a competitive edge.</p>
    //                     </div>
                        
    //                 </div>
    //             </div>

    //             <div className="row justify-content-between align-items-center">
    //                 <div className="col-xl-8">
    //                     <div className="advance-trading-img">
    //                         <img src="images/advancetrading.png" alt="Advanced Trading" className="img-fluid" />
    //                     </div>
    //                 </div>
    //                 {/* <div className="col-xl-4">
    //                     <div className="advance-trading-content">
    //                         <h4>Powerful API</h4>
    //                         <p>Access and manage your trades effortlessly using our robust and user-friendly API, which integrates seamlessly with your trading platform and offers advanced order options for enhanced control.</p>
    //                     </div>
    //                     <div className="advance-trading-content">
    //                         <h4>Leverage up to 100x</h4>
    //                         <p>Take advantage of up to 100x leverage on Bitcoin CFDs, giving you the potential to maximize returns on your trades with minimal capital outlay.</p>
    //                     </div>
    //                     <div className="advance-trading-content">
    //                         <h4>Deep Liquidity</h4>
    //                         <p>Our proprietary multi-market order technology enhances liquidity across various assets, tightening spreads, reducing slippage, and enabling smoother execution, even during high volatility.</p>
    //                     </div>
    //                 </div> */}
    //             </div>
    //         </div>
    //     </div>
    // );
};

export default AdvanceTrading;
